import { render } from "./ModalIdle.vue?vue&type=template&id=92855fa4&scoped=true"
import script from "./ModalIdle.vue?vue&type=script&lang=js"
export * from "./ModalIdle.vue?vue&type=script&lang=js"

import "./ModalIdle.vue?vue&type=style&index=0&id=92855fa4&lang=postcss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-92855fa4"]])

export default __exports__